import { FC, useContext } from 'react';
import styled from 'styled-components';

import LocalizedLink from '@/components/LocalizedLink/LocalizedLink';
import { getImage } from '@/lib/fetchAPI';
import { parseHTML } from '@/lib/parse';
import { translate } from '@/lib/translate';
import { GlobalContext } from '@/pages/_app';

const Recommended: FC<any> = ({ data }) => {
	const { lang } = useContext(GlobalContext);

	return (
		<Wrapper>
			<Title>
				{translate(lang, {
					en: 'Recommended',
					ru: 'Рекомендуемые',
					ua: 'Рекомендовані',
				})}
			</Title>

			<Posts>
				{data?.map((post, index) => (
					<Post key={`recommended_post_${index}`}>
						<LocalizedLink href={`/blog/post/${post?.url}/`}>
							<PostImageWrapper>
								<PostImage
									alt={post?.article?.title}
									src={getImage(post?.preview)} // TODO: check the image
								/>
							</PostImageWrapper>

							<PostTitle>{parseHTML(post?.article?.title)}</PostTitle>
						</LocalizedLink>
					</Post>
				))}
			</Posts>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	background-color: var(--color-white-30);
	border-radius: 16px;
	padding: 20px;
	padding-bottom: 10px;

	@media (max-width: 470px) {
		padding: 15px;
		padding-top: 20px;
	}

	@media (max-width: 400px) {
		padding: 35px;
		border-radius: 25px;
	}
`;

const Posts = styled.div`
	@media (max-width: 800px) {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	@media (max-width: 690px) {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
`;

const Post = styled.div`
	margin-bottom: 20px;

	@media (max-width: 800px) {
		width: 33%;
	}

	@media (max-width: 690px) {
		display: flex;
		width: 31%;
	}

	@media (max-width: 560px) {
		width: 46%;
	}

	@media (max-width: 470px) {
		width: 48%;
	}

	@media (max-width: 400px) {
		width: 100%;
	}

	a {
		text-decoration: none;
	}

	img {
		@media (max-width: 600px) {
			width: 100%;
		}
	}
`;

const Title = styled.h4`
	font-family: var(--font-sans);

	font-weight: var(--font-bold);
	font-size: 14px;
	line-height: 15px;
	text-transform: uppercase;
	color: var(--color-black);
	margin-bottom: 20px;
`;

const PostImageWrapper = styled.div`
	width: 100%;
	padding-top: 48%;
	overflow: hidden;
	position: relative;
	border-radius: 12px;
`;

const PostImage = styled.img`
	display: block;
	width: 100%;
	max-width: 100%;
	position: absolute;
	top: 0;
`;

const PostTitle = styled.h5`
	margin-top: 12px;
	font-family: var(--font-sans);

	font-size: 16px;
	line-height: 24px;
	color: var(--color-purple);
`;
export default Recommended;
